import { Stack, useTheme } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListStateIconFresh } from "source/components/framework/List/ListStateIconFresh";
import { ListStateIconLocked } from "source/components/framework/List/ListStateIconLocked";
import { ListStateIconUnread } from "source/components/framework/List/ListStateIconUnread";
import { IAppReportListItem } from "ui/Scripts/source/models/appReport/appReportListItem";
import { AppReportListStateChip } from "./AppReportListStateChip";
import { ListStateIconUnpublished } from "source/components/framework/List/ListStateIconUnpublished/listStateIconUnpublished";

interface IAppReportListStateColProps {
    item: IAppReportListItem
}

export const AppReportListStateCol = (props: IAppReportListStateColProps) => {
    const theme = useTheme();

    return (
        <Stack direction="row" useFlexGap flexWrap="nowrap" overflow="hidden" alignItems="center">
            <AppReportListStateChip
                code={props.item.archiveUser
                    ? Translations.Archived
                    : (props.item.publishUser
                        ? Translations.Published
                        : Translations.Draft)}
                color={props.item.archiveUser
                    ? theme.palette.stateGray.main //Archived
                    : (props.item.publishUser
                        ? theme.palette.stateGreen.main //Published
                        : theme.palette.stateGray.main //Draft
                    )}
            />
            {props.item.canEdit && !!props.item.publishUser && props.item.publishUser.date < props.item.modifyUser.date &&
                <ListStateIconUnpublished tooltip={Translations.ReportIsModifiedAfterItWasPublished} />
            }
            <ListStateIconUnread unread={!props.item.isRead} />
            <ListStateIconFresh date={props.item.modifyUser.date} />
            {props.item.canEdit &&
                <ListStateIconLocked locked={props.item.locked} />
            }
        </Stack>
    );
};
